<template>

    <div id="pdfComponent">
        <h4 class="titleClass">{{title}}</h4>
        <ejs-pdfviewer id="pdfViewer" :serviceUrl="serviceUrl" :documentPath="documentPath"> </ejs-pdfviewer>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { PdfViewerPlugin, Toolbar, Magnification, Navigation, LinkAnnotation, BookmarkView, ThumbnailView, Print, TextSelection, TextSearch} from '@syncfusion/ej2-vue-pdfviewer';
    import urls from '../../common/urls';
    import store from '../../store';
    Vue.use(PdfViewerPlugin);

    export default {
        name: 'PdfComponent',
        created() {
            title: this.$route.params.contract;
        },
        data() {
            return {
                serviceUrl: `${urls.apiBaseUrl}pdfviewer`,
                documentPath: decodeURIComponent(this.$route.params.fileName),
                title: this.$route.params.contract
                

            };
            
        },
        provide: {
            PdfViewer: [Toolbar, Magnification, Navigation, LinkAnnotation, BookmarkView, ThumbnailView, Print, TextSelection, TextSearch]
        }
    }
</script>

<style scoped>
    #pdfViewer {
        height: 800px;
        min-height: 800px!important;
    }
</style>